<template>
  <el-tabs type="border-card">
    <el-tab-pane label="用户报表">
      <div class="el-icon-warning-outline">条件查询</div>
      <div class="condition-css">
        <el-form ref="form" :model="form" >
          <span>查询日期：</span>
          <el-date-picker
            v-model="form.startDateStr"
            value-format="yyyy-MM-dd"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions">
          </el-date-picker>
          <el-button size="mini" type="primary" icon="el-icon-search" style="margin-left: 20px" @click="querySubmit">搜索</el-button>
        </el-form>
      </div>
      <div class="el-icon-warning-outline">数据概况</div>
      <div class="box-css">
        <span class="box-other box-lite">
          总新增：{{userData.totalCount}}
        </span>
        <span class="box-other box-lite">
          最近新增：{{userData.newCount}}
        </span>
        <span class="box-other box-lite">
          最小新增：{{userData.minCount}}
        </span>
        <span class="box-other box-lite">
          最大新增：{{userData.maxCount}}
        </span>
      </div>
      <div class="el-icon-warning-outline">用户数据</div>
      <div class="condition-css">
        <div id="myChart"  :style="{width: '112%', height: '420px', margin: '0 0 0 -120px'}"></div>
      </div>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
// 引入柱状图组件
require('echarts/lib/chart/bar')
// 引入提示框和title组件
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')

export default {
  data() {
    return {
      data: [],
      activeName: "1",
      showKey: true,
      userData: {
        minCount: 0,
        maxCount: 0,
        newCount: 0,
        totalCount: 0
      },
      form: {
        token: this.user.getToken(),
        startDateStr: []
      },
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      dataDefualt: [
      ],
      error: ""
    };
  },
  methods: {
    querySubmit: function() {
      console.log(this.form.startDateStr)
      this.getUserData()
    },
    getUserData: function() {
      this.http.post(
        '/home/user/count', 
        this.form, res => {
          if (res.success) {
            // 返回正确的处理
            let userCountList = res.datas.data.userCountList

            this.userData.totalCount = res.datas.data.totalCount
            this.userData.newCount = res.datas.data.newCount
            this.userData.minCount = res.datas.data.minCount
            this.userData.maxCount = res.datas.data.maxCount

            // 引入基本模板
            let echarts = require('echarts/lib/echarts')
            // 基于准备好的dom，初始化echarts实例
            let myChart = echarts.init(document.getElementById('myChart'))
            var dateList = userCountList.map(function (item) {
                return item[0];
            });
            var valueList = userCountList.map(function (item) {
                return item[1];
            });
            // 绘制图表
            myChart.setOption({
              visualMap: [
                {
                  show: false,
                  type: 'continuous',
                  seriesIndex: 0,
                  min: 0,
                  max: 20
                },
              ],
              title: { left: 'center',text: '新增用户数据' },
              tooltip: {
                  left: 'center',
                  trigger: 'axis'
              },
              xAxis: {
                  data: dateList,
              },
              yAxis: {
              },
              grid: {
                  bottom: '25%'
              },
              series: {
                type: 'line',
                showSymbol: false,
                data: valueList,
              }
            });
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
      });
    },
    getCurrentMonthFirst () {
      var date = new Date()
      date.setDate(1)
      var month = parseInt(date.getMonth() + 1)
      var day = date.getDate()
      if (month < 10)  month = '0' + month
      if (day < 10)  day = '0' + day
      return date.getFullYear() + '-' + month + '-' + day
    },
  },
  validations: {
  },
  mounted: function() {
    console.log("初始化..........")
    const end= new Date()
    const start = new Date(this.getCurrentMonthFirst ())
    this.form.startDateStr = [start, end]
    this.getUserData()
  }
};
</script>
<style>

.condition-css {
  margin-top: 6px;
  padding: 20px;
  border: 1px solid #eee;
  margin-bottom: 20px;
}
.report-css {
  border: 1px solid #eee;
}
.box-css {
  margin-top: 6px;
  display: flex;
  padding: 15px 20px;
  border: 1px solid #eee;
  margin-bottom: 20px;
}
.box-other {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 14%;
  margin: 0 30px 0 40px;
  border-radius: 4px 4px 4px 4px!important;
  padding: 10px 20px;
  background: #F2F6FC;
}
.box-lite {
  color: #9a9a9a;
}
</style>


// WEBPACK FOOTER //
// src/components/views/home/reportUser.vue